import React from 'react'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import ShiftUpdateDetailsTemplate from 'redesign/components/templates/ShiftUpdateDetails/ShiftUpdateDetails'
import { useShiftUpdateDetailPage } from 'redesign/pages/ShiftUpdateDetails/useShiftUpdateDetailPage'
import { Container } from './styles'
import type { ShiftUpdateMenuOptionProps } from './types'

const ShiftUpdateMenuOption: React.FC<ShiftUpdateMenuOptionProps> = ({ favurUuid, onRefresh }) => {
  const { updatedDays, shiftsUpdatedByDate, shiftsUpdatedHistoryByDate, loading } = useShiftUpdateDetailPage({
    favurUuid,
    onRefresh,
  })

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <Container>
      <ShiftUpdateDetailsTemplate
        updatedDays={updatedDays}
        shiftsUpdatedByDate={shiftsUpdatedByDate}
        shiftsUpdatedHistoryByDate={shiftsUpdatedHistoryByDate}
      />
    </Container>
  )
}

export default ShiftUpdateMenuOption
